import api from "../../../services/axiosConfig";

export const fetchDataSources = async () => {
  try {
    const response = await api.get("/instances/skeye/skeyechart/datasources", {
      data: {},
    });
    return response.data.data.datasources;
  } catch (error) {
    console.error("Error fetching datasources:", error);
    throw error;
  }
};
